<mat-paginator #paginatorTop [length]="fileCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event); paginatorBottom.pageIndex = $event.pageIndex; paginatorBottom.pageSize = $event.pageSize">
</mat-paginator>

<div class="loading" *ngIf="dataLoading">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="!dataLoading">


    <h1 *ngIf="currentCategory" style="margin-top:-50px;margin-bottom:0;">{{ currentCategory.title }}</h1>
    <mat-grid-list [cols]="nbCols" rowHeight="250px" gutterSize="20px">
      <mat-grid-tile *ngFor="let product of products">

        <app-slide class="product-grid-tile" [item]=product [imageSrc]=product.image_file [thumbHeight]="150">

        </app-slide>
      </mat-grid-tile>
    </mat-grid-list>

</div>

<mat-paginator #paginatorBottom [length]="fileCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event); paginatorTop.pageIndex = $event.pageIndex; paginatorTop.pageSize = $event.pageSize">
</mat-paginator>



// WEBPACK FOOTER //
// ./src/app/products/products.component.html